<template>
    <div class="modal fade" id="chatBoxModal" ref="chatBoxModal" tabindex="-1" aria-labelledby="warning" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div id="chatBoxModalHeader" class="modal-header bg-gradient-warning p-2">
          <button type="button" class="btn-close" aria-label="Close" @click="closeChatBoxModal"></button>
        </div>
        <div>
          <div class="modal-body d-flex flex-column">
            <label for="OpenTicketDescription" class="form-label required">توضیحات</label>
            <div class="d-flex">
              <textarea class="form-control" rows="3" id="OpenTicketDescription" name="OpenTicketDescription"
                v-model.trim="modalDescription"></textarea>
            </div>
          </div>
          <div class="modal-footer d-flex justify-content-between">
            <button type="button" class="btn bg-gradient-warning" @click="openTicket">باز کردن تیکت</button>
            <button type="button" class="btn bg-gradient-secondary" @click="closeChatBoxModal">انصراف</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div id="ticketDetailChatBox" class="chat-box">
    <div class="chat-box-header fs-4">
      <div class="d-flex justify-content-between align-items-center">
        <fa-layers class="mx-2 pointer" @click="ticketBookmarkToggle">
          <fa-icon class="c-yellow-600" icon="fas fa-bookmark" size="lg" />
          <fa-icon :class="ticket.isBookmarked ? 'c-yellow-600' : 'text-white'" icon="fas fa-bookmark" transform="up-1" />
        </fa-layers>
        <div class="d-flex flex-wrap flex-fill">
          <div class="text-break mx-2">#{{ ticket.ticketCode }} {{ ticket.title }}</div>
          <div v-for="l in ticket.labels" class="chatbox-header-label fs-6 align-self-center my-0 mx-2 px-1 h-50">
            <div v-if="getPermission(1140).insert" class="d-inline text-danger ms-1 pointer" @click="removeLabel(l.id)">x</div>
            <div class="d-inline text-dark mx-1">{{ l.title }}</div>
          </div>
          <div v-if="getPermission(1140).insert">
            <div @click="toggleShowOtherLabels()"
              class="d-inline chatbox-header-label-add fs-6 align-self-center my-0 mx-2 h-50 pointer"
              :class="showOtherLabels ? 'text-secondary' : 'text-success'">
                {{ showOtherLabels ? "-" : "+" }}
            </div>
            <div v-if="showOtherLabels" class="position-relative d-inline">
              <div class="position-absolute top-100 start-0 d-flex flex-column">
                <div v-for="ol in otherLabels" class="btn alert-success text-white text-nowrap m-0 mt-1 p-1 px-3"
                  @click="addLabel(ol.id)">
                  {{ ol.title }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex align-items-center align-self-stretch">
          <div class="status chat-box-header-status fs-6 d-flex align-items-center"
            :class="ticket.ticketStatusHistories?.[0]?.ticketStatus?.ticketStatusEnum == 0 ? 'status-danger' :
              ticket.ticketStatusHistories?.[0]?.ticketStatus?.ticketStatusEnum == 1 ? 'status-warning' :
              ticket.ticketStatusHistories?.[0]?.ticketStatus?.ticketStatusEnum == 2 ? 'status-primary' :
              ticket.ticketStatusHistories?.[0]?.ticketStatus?.ticketStatusEnum == 3 ? 'status-success' :
              ticket.ticketStatusHistories?.[0]?.ticketStatus?.ticketStatusEnum == 7 ? 'status-warning' : 'status-secondary'">
            {{ ticket.ticketStatusHistories ? ticket.ticketStatusHistories?.[0]?.ticketStatus?.title : "" }}
          </div>
        </div>
      </div>
    </div>
    <div id="tDChatList" ref="tDChatList" class="chat-list d-flex flex-column-reverse">
      <div v-for="td in ticketDetails" class="d-flex flex-column p-0 m-0">
        <div v-if="td.isDate" class="chat-date d-flex align-self-center m-3" dir="ltr">
          {{ $filters.toSpacedDateString(td.value) }}
        </div>
        <ticket-detail-chat v-else :ticketDetail="td" :ticketId="ticket.id" :ticketIsClosed="ticketIsClosed"
          :dynamicId="td.isReferral ? ('tRChat-' + td.id) : ('tDChat-' + td.id)"
          @submited="submited" @setToBeReplied="setChatToBeReplied" @repliedChatSelected="scrollToChat" />
      </div>
    </div>
    <div id="tDchatFooter">
      <form @submit.prevent="submitForm()"
        v-if="(
                !ticketIsClosed
                &
                (currentUserInfo.id == ticket.createUser?.id | (currentUserInfo.isAdmin & !currentUserInfo.isCompanyUser))
              )
              |
              (
                (
                  !(ticket.lastCompanySection?.hasConfidentialConversations)
                  | getPermission(1050).view
                  | currentUserInfo.companySections.map(x => x.id).includes(ticket.lastCompanySection?.id)
                )
                &
                (getPermission(1140).insert | (!ticketIsClosed & getPermission(1130).update))
              )">
        <div class="chat-footer d-flex flex-column pt-1">
          <div v-if="toBeRepliedChat" class="d-flex justify-content-between p-1">
            <replied-chat-display class="me-3" :chat="toBeRepliedChat" @click="scrollToChat(toBeRepliedChat)" />
            <button type="button" class="btn-close btn-close-white align-self-center mx-2" aria-label="Close" @click="removeChatToBeReplied"></button>
          </div>
          <div class="d-flex">
            <div class="d-flex align-items-center mb-1">
              <fa-icon class="pointer ps-2 pe-2 text-hover-success" icon="fas fa-paper-plane" size="2x" title="ارسال" @click="submitForm" />
            </div>
            <div class="flex-fill mb-1">
              <div ref="inputDiv" contenteditable type="input" class="editable form-control text-break"
              @keydown.ctrl.enter.prevent="submitForm" placeholder="ارسال: ctrl + enter"></div>
            </div>
            <div>
              <chat-file-selector ref="chatFileSelector" dynamicId="tdcb" maxFileCount="5" :maxFileSize="50 * 1024 * 1024"
              validExtensions="rar,zip,doc,docx,pdf,xls,xlsx,ppt,pptx,txt,apng,png,avif,gif,jpg,jpeg,jfif,pjpeg,pjp,svg,webp"
              @filesUpdate="updateFiles" />
            </div>
            <div v-if="getPermission(1140).insert" class="d-flex align-items-center mb-2">
              <fa-icon class="pointer ps-1 pe-0" :icon="expandFooter ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
                size="1x" :title="expandFooter ? 'بستن' : 'امکانات بیشتر'" @click="expandFooter = !expandFooter" />
            </div>
          </div>
          <div v-if="expandFooter" class="row">
            <div class="d-flex justify-content-center col-md-6 mb-1">
              <label class="form-control-label">زمان صرف شده: </label>
              <date-picker class="me-2 ms-2" clearable editable format="HH:mm:ss" displayFormat="HH:mm" v-model="timeSpent" type="time"
                :jump-minute="5" :jumpSecond="60" :round-minute="true" initial-value="00:00" />
            </div>
            <div class="d-flex col-md-6 mb-1">
              <div class="flex-fill me-2">
                <vue-select class="chat-footer-input" v-model="status" :options="statuses" dir="rtl" label="title" placeholder="عدم تغییر وضعیت ...">
                  <template #no-options="{ search, searching, loading }">
                      موردی یافت نشد!
                    </template>
                </vue-select>
              </div>
              <div class="d-flex align-items-center">
                <fa-icon class="pointer ps-2 pe-2 text-hover-warning" icon="fas fa-clipboard-check" size="2x" title="تغییر وضعیت بدون ثبت توضیح" @click="changeStatus" />
              </div>
            </div>
          </div>
        </div>
      </form>
      <div v-else class="d-flex justify-content-center chat-footer bg-light"
        :class="currentUserInfo.id == ticket.createUser.id ? '' : 'chat-footer-empty'">
        <div v-if="currentUserInfo.id == ticket.createUser.id" class="btn btn-sm bg-gradient-secondary my-1"
          @click="openChatBoxModal">
          باز کردن تیکت
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TicketDetailChat from './TicketDetailChat.vue';
import ChatFileSelector from '../File/ChatFileSelector.vue';
import BaseService from '../../../services/Base-service';
import { mapGetters } from "vuex";
import PersianDateTime from "vue3-persian-datetime-picker";
import RepliedChatDisplay from './RepliedChatDisplay.vue';

import TicketService from '@/services/Ticket/Ticket-service.js';
import LabelService from '@/services/Ticket/LabelService.js';

export default {
  components: { TicketDetailChat, ChatFileSelector, RepliedChatDisplay, PersianDateTime },
  props: {
    ticket: {
      type: Object,
    }
  },
  emits: ['submited', 'bookmarkToggle'],
  data() {
    return {
      message: '',
      files: [],
      // currentUserInfo: {},
      scrolledIntoView: false,
      expandFooter: false,
      status: null,
      statuses: [],
      timeSpent: null,
      toBeRepliedChat: null,
      modalDescription: '',
      otherLabels: [],
      showOtherLabels: false,
    };
  },
  computed: {
    ...mapGetters(['getPermission', 'currentUserInfo']),
    ticketDetails() {
      if (this.ticket?.ticketDetails?.length > 0) {
        let dates = this.ticket?.ticketDetails.map(x => x.createDate);

        this.ticket.ticketDetails[0].isFirst = true;

        let ticketDetails = [...this.ticket.ticketDetails, ...dates.map(x => ({ value: x, sortProp: (x + '000000'), isDate: true }))];
        ticketDetails = ticketDetails.filter((detail, index, details) => details.map(x => x.sortProp).indexOf(detail.sortProp) === index);

        ticketDetails.forEach(td => {
          if (td.repliedTicketDetailId) {
            const repliedIndex = ticketDetails.filter(x => !x.isReferral).map(x => x.id).indexOf(td.repliedTicketDetailId);

            if (repliedIndex > -1)
              td.repliedTicketDetail = ticketDetails[repliedIndex];
          }
        });

        setTimeout(() => {
          if (!this.scrolledIntoView) {
            this.focusInputDiv();
          }
        }, 100);

        ticketDetails.sort((a, b) => { return b.sortProp - a.sortProp });

        ticketDetails[0].isLast = true;

        return ticketDetails;
      }
    },
    ticketIsClosed() {
      return [4, 5, 6].includes(this.ticket.ticketStatusHistories?.[0]?.ticketStatus?.ticketStatusEnum);
    }
  },
  watch: {
    ticket() {
      if (this.getPermission(1140).insert) {
        this.getStatusesByCompany();
      }
    },
    timeSpent(time){
      if (time < "00:00:60"){
        time = null;
      }
    }
  },
  methods: {
    // submitForm() {
    //   this.message = this.$refs.inputDiv?.innerText?.trim();

    //   if (!(this.message?.length > 0)) { return; }

    //   let postFileAddrees = '/Ticket/AddTicketDetail';

    //   let ticketDetail = new FormData();
    //   ticketDetail.append('Message', this.message);
    //   ticketDetail.append('TicketId', this.ticket.id);

    //   for (var i = 0; i < this.files.length; i++) {
    //     ticketDetail.append("Files", this.files[i]);
    //   }

    //   BaseService.postFile(postFileAddrees, ticketDetail).then(response => {
    //     let result = response.data;

    //     if (result.success) {
    //       this.message = '';
    //       this.$refs.inputDiv.innerText = '';
    //       this.$refs.chatFileSelector.files = [];
    //     } else {
    //       this.$toast.error(result.message);
    //     }
    //   }).then(() => {
    //     this.$emit('submited');
    //   }).catch(e => {
    //     console.log(e);
    //   });
    // },
    updateFiles(files) {
      this.files = files;
    },
    submitForm() {
      this.message = this.$refs.inputDiv?.innerText?.trim();

      if (!(this.message?.length > 0)) { return; }

      let postFileAddrees = '';
      if (this.getPermission(1140).insert) { postFileAddrees = '/Ticket/AddTicketDetailWithStatus'; }
      else { postFileAddrees = '/Ticket/AddTicketDetail' }

      let ticketDetail = new FormData();
      ticketDetail.append('Message', this.message);
      ticketDetail.append('TicketId', this.ticket.id);
      if (this.status) {
        ticketDetail.append('TicketStatusId', this.status.id);
      }
      if (this.timeSpent > '00:00:59') {
        ticketDetail.append('TimeSpent', this.timeSpent.slice(0,6) + "00");
      }
      for (var i = 0; i < this.files.length; i++) {
        ticketDetail.append("Files", this.files[i]);
      }
      if (this.toBeRepliedChat) {
        ticketDetail.append('RepliedTicketDetailId', this.toBeRepliedChat.id);
      }

      BaseService.postFile(postFileAddrees, ticketDetail).then(response => {
        let result = response.data;

        if (result.success) {
          this.message = '';
          this.$refs.inputDiv.innerText = '';
          this.status = null;
          this.timeSpent = null;
          this.$refs.chatFileSelector.files = [];
          this.removeChatToBeReplied();
        } else {
          this.$toast.error(result.message);
        }
      }).then(() => {
        this.$emit('submited');
      }).catch(e => {
        console.log(e);
      });
    },
    getStatusesByCompany() {
      TicketService.getStatusesByCompany(this.ticket.companyId).then(response => {
        let result = response.data;
        if (result.success) {
          this.statuses = result.data;
        }
        else {
          this.$toast.error(result.message);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    changeStatus() {
      if (this.status) {
        let statusHistory = {
          ticketId: this.ticket.id,
          ticketStatusId: this.status.id,
        };

        TicketService.changeTicketStatus(statusHistory).then(response => {
          let result = response.data;

          if (!result.success) {
            this.$toast.error(result.message);
          } else {
            this.$toast.success(result.message);
            this.status = null;
          }
        }).then(() => {
          this.$emit('submited');
        }).catch(e => {
          console.log(e);
        });
      }
      else {
        this.$toast.error("لطفا وضعیت مورد نظر را مشخص کنید");
      }
    },
    submited() {
      this.$emit('submited');
    },
    setChatToBeReplied(chat) {
      this.deselectAllChats();

      this.toBeRepliedChat = chat;

      this.focusInputDiv();
    },
    removeChatToBeReplied() {
      this.deselectAllChats();

      this.toBeRepliedChat = null;
    },
    selectChat(chat) {
      const index = this.ticket.ticketDetails.filter(x => x.isReferral == chat.isReferral).map(x => x.id).indexOf(chat.id);

      if (index > -1)
        this.ticket.ticketDetails[index].selected = true;
    },
    deselectAllChats() {
      const listOfSelectedChat = this.ticket.ticketDetails.filter(x => x.selected);

      listOfSelectedChat.forEach((c) => {
        c.selected = false;
      });
    },
    scrollToChat(chat) {
      this.deselectAllChats();

      const chatList = document.getElementById('tDChatList');
      const chatEl = document.getElementById(chat.isReferral ? ('tRChat-' + chat.id) : ('tDChat-' + chat.id));

      const topPos = chatEl.offsetTop - chatList.offsetTop - chatList.clientHeight / 2 + chatEl.clientHeight / 2;
      chatList.scrollTop = topPos;

      this.selectChat(chat);
    },
    focusInputDiv() {
      let chatBox = document.getElementById('ticketDetailChatBox');
      chatBox.scrollIntoView({ behavior: 'smooth', block: 'center' });

      this.$refs.inputDiv?.focus();

      this.scrolledIntoView = true;
    },
    ticketBookmarkToggle() {
      TicketService.ticketBookmarkToggle(this.ticket.id).then(response => {
        let result = response.data;

        if (result.success) {
          this.$emit('bookmarkToggle');
        }
        else
         this.$toast.error(result.message);
      }).catch(e => {
        console.log(e);
      });
    },
    openTicket() {
      if (!this.modalDescription) {
        this.$toast.error('لطفا توضیحات مربوطه را ثبت کنید');
        return;
      }

      this.lockButtons = true;

      let postFileAddrees = '/Ticket/OpenTicketByOwner';

      let ticketDetail = new FormData();
      ticketDetail.append('Message', this.modalDescription);
      ticketDetail.append('TicketId', this.ticket.id);

      // for (var i = 0; i < this.files.length; i++) {
      //   ticketDetail.append("Files", this.files[i]);
      // }

      BaseService.postFile(postFileAddrees, ticketDetail).then(response => {
        let result = response.data;

        if (result.success) {
          this.$toast.success(result.message);
          this.modalDescription = '';

          this.closeChatBoxModal();
        } else {
          this.$toast.error(result.message);
        }

        this.lockButtons = false;
        this.submited();
      }).catch(e => {
        console.log(e);
      });
    },
    openChatBoxModal() {
      this._modalInstance.show();
    },
    closeChatBoxModal() {
      this._modalInstance.hide();
    },
    toggleShowOtherLabels() {
      if (this.showOtherLabels) {
        this.showOtherLabels = false;

        return;
      }

      if (this.otherLabels.length == 0)
        this.getLabels();

      this.showOtherLabels = true;
    },
    getLabels() {
      LabelService.listCompanyLabels(false).then(response => {
        let result = response.data;

        if (result.success)
          this.otherLabels = result.data.filter(l => this.ticket.labels.map(x => x.id).indexOf(l.id) < 0);
        else
          this.$toast.error(result.message);
      }).catch(e => {
        console.log(e);
      });
    },
    addLabel(labelId) {
      LabelService.toggleLabelForTicket(labelId, this.ticket.id).then(response => {
        let result = response.data;

        if (result.success) {
          this.ticket.labels = [...this.ticket.labels, ...this.otherLabels.filter(l => l.id == labelId)];
          
          this.otherLabels = this.otherLabels.filter(l => l.id != labelId);
        }
        else
          this.$toast.error(result.message);
      }).catch(e => {
        console.log(e);
      });
    },
    removeLabel(labelId) {
      LabelService.toggleLabelForTicket(labelId, this.ticket.id).then(response => {
        let result = response.data;

        if (result.success) {
          if (this.otherLabels.length > 0)
            this.otherLabels = [...this.otherLabels, ...this.ticket.labels.filter(l => l.id == labelId)];
          
          this.ticket.labels = this.ticket.labels.filter(l => l.id !== labelId);
        }
        else
          this.$toast.error(result.message);
      }).catch(e => {
        console.log(e);
      });
    }
  },
  mounted() {
    this._modalInstance = new bootstrap.Modal(this.$refs.chatBoxModal);

    // this.currentUserInfo = this.$store.state.currentUserInfo;
    // this.currentUserInfo.companySections = [...this.$store.state.currentUserInfo.companySections];
    //console.log(this.currentUserInfo)
  },
}
</script>
